'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentThreadId = undefined;

var _reselect = require('reselect');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getCurrentConversation = require('./getCurrentConversation');

var getCurrentThreadId = exports.getCurrentThreadId = (0, _reselect.createSelector)([_getCurrentConversation.getCurrentConversation], function (currentConversation) {
  return (0, _threadGetters.getThreadId)(currentConversation) || null;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/conversationSelectors/getCurrentThreadId.js
// module id = 105
// module chunks = 2 3